// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"56":"5173b43c","81":"f604fcb9","133":"31135e01","271":"a0d67f28","326":"6f72c5bb","344":"e1831a77","453":"258b012d","565":"1c11b3c5","628":"18ad7718","716":"e04fdb9b","796":"1905bba4","804":"9ea1fcc7","905":"502ead7d","949":"c0bb6183"}[chunkId] + ".chunk.js";
};